import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text, Theme, Button } from '@simplybenefits/sb-ui-library';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell/TableCell";
import TableBody from "@mui/material/TableBody";
import * as dates from "@simplybenefits/sb-dates";

class Notes extends Component {
    state = {
        selectedNote: null
    };

    _toggleNote = (note) => {
        if (note !== this.state.selectedNote) {
            this.setState({
                selectedNote: note
            });

            return;
        }

        if (this.state.selectedNote) {
            this.setState({
                selectedNote: null
            });
        } else {
            this.setState({
                selectedNote: note
            });
        }
    };

    /**
     * @param body
     * @returns {string}
     * @private
     */
    _truncate = (body) => {
        if (body.length > 80) {
            return `${ body.substring(0, 80) }...`;
        }

        return body;
    };

    render() {
        const { notes, isClaimView } = this.props;
        const styles = {
            container: {
                flex: 1,
                border: "2px solid #F1F1F1",
                borderRadius: 5,
                backgroundColor: '#FFF',
                padding: 20
            },
            claimViewContainer: {
                flex: 1,
                backgroundColor: '#FFF',
                padding: 0
            },
            table: {
                display: 'block',
                overflowX: 'auto',
                paddingBottom: '20px',
                width: '100%',
                border: "2px solid #F1F1F1",
                backgroundColor: '#FFF'
            },
            scrollbar: {
                '&::webkitScrollbar': {
                    height: '15px',
                    width: '15px'
                },
                '&::webkitSrollbarThumb': {
                    backgroundColor: Theme.colors.surface,
                    borderRadius: '10px',
                    boxShadow: 'inset 0 0 2px rgba(0, 0, 0, .5)'
                },
                '&::webkitScrollbarTrack': {
                    backgroundColor: Theme.colors.backgroundGrey,
                    borderRadius: '10px',
                    boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.2)'
                }
            },
            tableHeading: {
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingRight: "2vw",
                paddingLeft: "2vw",
                fontFamily: Theme.fonts.type.heading,
                color: Theme.colors.surface,
                whiteSpace: "nowrap",
                border: "none"
            },
            tableCell: {
                paddingTop: "10px",
                paddingBottom: "10px",
                fontFamily: Theme.fonts.type.light,
                whiteSpace: "nowrap",
                paddingRight: "2vw",
                paddingLeft: "2vw",
                color: Theme.colors.mainTextGrey
            }
        };

        if (!notes || notes.length === 0) {
            return (
                <Text
                    medium
                    color={ Theme.colors.mainTextGrey }
                >
                    No notes available.
                </Text>
            );
        }

        return (
            <div style={ isClaimView ? styles.claimViewContainer : styles.container }>
                <div style={{ overflow: "auto", maxHeight: 600, ...styles.scrollbar }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: Theme.colors.skyBlue }}>
                                <TableCell style={styles.tableHeading}>
                                    Note
                                </TableCell>

                                <TableCell style={styles.tableHeading}>
                                    Author
                                </TableCell>

                                <TableCell style={styles.tableHeading}>
                                    Created
                                </TableCell>

                                <TableCell style={styles.tableHeading} />
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {
                                notes.map((note, index) => {
                                    let backgroundObject = { border: "none" };
                                    if (index % 2 !== 0) {
                                        backgroundObject = { backgroundColor: Theme.colors.backgroundGrey, border: "none" };
                                    }

                                    return (
                                        <React.Fragment key={note.memNoteID}>
                                            <TableRow>
                                                <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                                    { this._truncate(note.body) }
                                                </TableCell>

                                                <TableCell style={{ ...styles.tableCell, ...backgroundObject }}>
                                                    { note.createdBy }
                                                </TableCell>

                                                <TableCell style={{ ...styles.tableCell, ...backgroundObject }} >
                                                    { dates.getLocalDisplay(note.dateAdded, 'lll') }
                                                </TableCell>

                                                <TableCell style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', ...styles.tableCell, ...backgroundObject }}>
                                                    {
                                                        (note.claimID && !isClaimView) &&
                                                        <Button transparent onClick={ () => {
                                                            window.location.href = `/adjudication/${ note.claimID }?${ note.userID }`;
                                                        }}>
                                                            View Claim
                                                        </Button>
                                                    }

                                                    <Button transparent onClick={ () => this._toggleNote(note) }>
                                                        {
                                                            this.state.selectedNote?.memNoteID === note.memNoteID ?
                                                                'Hide Full'
                                                                :
                                                                'View Full'
                                                        }
                                                    </Button>
                                                </TableCell>
                                            </TableRow>

                                            {
                                                this.state.selectedNote?.memNoteID === note.memNoteID &&
                                                <TableRow>
                                                    <TableCell style={{ ...styles.tableCell, ...backgroundObject }} colSpan={4}>
                                                        <Text formatted bold>{ note.body }</Text>
                                                    </TableCell>
                                                </TableRow>
                                            }
                                        </React.Fragment>
                                    ); 
                                })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default (connect()(Notes));